
import { HelpService } from './../../help/help.service';
import { LevelingComponent } from './../../../widgets/leveling/leveling.component';
import { InfoBoxService } from 'src/app/services/info-box.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DxDataGridComponent } from 'devextreme-angular';
import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { NotificationService } from 'src/app/services/notification.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { SettingsService } from '../../settings/settings.service';
import { EsoService, SupplyForecastChartDto } from '../eso.service';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { FileExportService } from 'src/app/common/file-export-service';
import { WindowService } from 'src/app/services/window.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { ActivatedRoute, Data } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { ActivatedRouteService } from 'src/app/services/activated-route.service';
import { CounterGroups } from 'src/app/services/loading-indication.service';

@Component({
    selector: 'app-supply-forecast-overview',
    templateUrl: './supply-forecast-overview.component.html',
    styleUrls: ['./supply-forecast-overview.component.scss'],
    standalone: false
})
export class SupplyForecastOverviewComponent implements OnInit {

	@ViewChild('leveling', { static: false })
	private levelingComponent: LevelingComponent;

	period = "period";
	chartData: SupplyForecastChartDto[] = [];
	periodList: string[] = [];
	selectedPeriod: string = ' ';
	barChartData: any[] = [];
	removeSupplyBarChartData: any[] = [];
	addSupplyBarChartData: any[] = [];

	tableValuesDataSource: any;
	tableColumnsDataSource: any;

	visualRange = {};

	quantityCaption: string;
	demandQuantityCaption: string;

	anyActiveFilters = false;

	issueResponsesDataSource: string[] = [];

	// <General>
	private readonly _componentTitle = "Supply Forecast";
	// </General>

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_ESOSupplyForecastOverviewTable,
				selectionSetId: SelectionSetId.EsoSupplyForecastFilters,
			}
		)
	);

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	@ViewChild('dataGrid', { static: false })
	public dataGrid: DxDataGridComponent;


	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dataGrid
			),
		];

		return routeData;
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
					}
				}
			}
		);
	}

	private focusedSelectedItems: boolean = false;

	public focusSelectedItems() {
		if (this.selectedTableRecords != null && this.selectedTableRecords.length > 0) {
			this.focusedSelectedItems = !this.focusedSelectedItems;

			this.update(false);
		}
		else {
			this.infoBoxService.show(
				{
					message: 'Please select at least one item from the below list.',
					title: 'Warning',
					displayTimeMs: -1
				}
			);
		}
	}

	public levelingPopupVisible: boolean = false;

	public openPopupLeveling() {
		if (this.selectedTableRecords != null && this.selectedTableRecords.length > 0) {
			this.levelingComponent.update();

			this.levelingPopupVisible = true;
		}
		else {
			this.infoBoxService.show(
				{
					message: 'Please select at least one item from the below list.',
					title: 'Warning',
					displayTimeMs: -1
				}
			);
		}
	}

	public fitTableToPage: boolean = false;

	public changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	public unsavedChanges: boolean = false;
	public changedTableRecords: any[] = [];

	public gridRowUpdated(event: any) {
		this.unsavedChanges = true;
		this.changedTableRecords.push(event.data);
	}

	public selectedTableRecords: any[] = [];

	public clearSelectedItem() {
		this.selectedTableRecords = [];
		this.dataGrid.instance.clearSelection();
	}

	public gridSelectionChanged(event: any) {
		this.selectedTableRecords = [];

		event.selectedRowKeys.forEach(
			(element: any) => {
				if (!this.selectedTableRecords.includes(element)) {
					this.selectedTableRecords.push(element);
				}
			}
		);
	}

	public saveAllChanges() {

	}

	public undoAllChanges() {
		if (this.unsavedChanges) {
			this.unsavedChanges = false;
		} else {
			this.infoBoxService.show(
				{
					message: 'No changes have been done yet.',
					title: 'Warning'
				}
			);
		}
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift(
			{
				location: 'before',
				template: 'expandButtonTemplate'
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			},
			{
				location: 'after',
				template: 'appliedFiltersButtonTemplate'
			},
			{
				location: 'before',
				template: 'selectionFocusButtonTemplate'
			},

		);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-eso-supply', JSON.stringify(this.dataGrid.instance.state()));
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	getChartCaptions() {
		this.settingsService.getGeneralSettings(
			{
				showLoadingIndicator: false,
			}
		).subscribe(res => {
			this.quantityCaption = res.settings.find(x => x.name === 'Supply Quantity Caption').value;
			this.demandQuantityCaption = res.settings.find(x => x.name === 'Supply Demand Quantity Caption').value;

			this.getChartData();
		});
	}

	getTableData() {
		this.esoService.getEsoSupplyForecastTableData(
			this.pageFiltersOperator.appliedFilters,
			this.selectedPeriod,
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: UtilsService.computeRouteHash(this._activatedRouteService.routeId, 2).toString()
			}
		).subscribe(res => {
			this.tableValuesDataSource = res.data;
			this.tableColumnsDataSource = res.columns;
			setTimeout(() => {
				this.LoadChartSeries();
			}, 1000);
		});
	}

	public getChartData() {
		this.barChartData = [
			{
				quantitySum: 0,
				demandQuantitySum: 0,
				caption: "Sum"
			},
			{
				quantitySum: 0,
				demandQuantitySum: 0,
				caption: "Remove Supply"
			},
			{
				quantitySum: 0,
				demandQuantitySum: 0,
				caption: "Add Supply"
			},
		];

		this.esoService.getSupplyForecastOverviewChartData(
			this.pageFiltersOperator.appliedFilters,
			this.selectedPeriod,
			this.focusedSelectedItems ? this.selectedTableRecords.map((value) => value.EsoObjectId) : null,
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: UtilsService.computeRouteHash(this._activatedRouteService.routeId, 0).toString()
			}
		).subscribe(
			(response) => {
				this.chartData = response;

				const quantitySum = this.chartData.reduce((a, b) => a + b.quantity, 0);
				const demandQuantitySum = this.chartData.reduce((a, b) => a + b.demandQuantity, 0);

				if (this.chartData.length > 0) {
					this.barChartData[0] = {
						quantitySum: quantitySum,
						demandQuantitySum: demandQuantitySum,
						caption: "Sum"
					};
				}
			}
		);

		this.esoService.getSupplyForecastOverviewChartData(
			this.pageFiltersOperator.appliedFilters,
			'DataSourceId',
			undefined,
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: UtilsService.computeRouteHash(this._activatedRouteService.routeId, 1).toString()
			}
		).subscribe(
			(response) => {
				const removeSupplyData = response.find(x => x.groupingField === '11');

				if (removeSupplyData) {

					this.barChartData[1] = {
						quantitySum: removeSupplyData.quantity ? removeSupplyData.quantity : 0,
						demandQuantitySum: removeSupplyData.demandQuantity ? removeSupplyData.demandQuantity : 0,
						caption: "Remove Supply"
					};
				}

				const addSupplyData = response.find(x => x.groupingField === '12');

				if (addSupplyData) {

					this.barChartData[2] = {
						quantitySum: addSupplyData.quantity ? addSupplyData.quantity : 0,
						demandQuantitySum: addSupplyData.demandQuantity ? addSupplyData.demandQuantity : 0,
						caption: "Add Supply"
					};
				}
			}
		);
	}

	getPeriodList() {
		this.esoService.getSupplyForecastPeriodList(
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: UtilsService.computeRouteHash(this._activatedRouteService.routeId, 2).toString()
			}
		).subscribe(res => {
			this.periodList = res;
			this.selectedPeriod = res[0];
		});
	}

	public isDropdown(type: HtmlControlType) {
		return type === HtmlControlType.Dropdown || type === HtmlControlType.List;
	}

	public update(updateTable: boolean = true): void {
		if (updateTable) {
			this.getTableData();
		}

		this.getChartData();
	}

	onPeriodChanged(e) {

		this.update();
	}

	resetPeriodToDefault() {
		this.selectedPeriod = '';

		this.getChartData();
	}

	public canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.tableColumnsDataSource.find(x => x.columnName === dataField);

		if (correspondingColumn && (correspondingColumn.columnName === 'PermanentComment' || correspondingColumn.columnName === 'IssueResponse')) {
			return true;
		}

		return false;
	}

	public onGridActionItemClicked(event: any, item: any) {
		console.log("onGridActionItemClicked - item:", item.data.ProductId);
		this.windowService.openInNewPage("/eso/deep-dive", {
			productId: item.data.ProductId,
		});
		event.event.stopPropagation();
	}

	public onHelpButtonClicked(event: any, settingName: string): void {
		console.log("onHelpButtonClicked - event:", event);

		this.helpService.openHelpPage(settingName);
	}

	/* Export Option */
	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings(
			"EnableExportEsoSupplyForecastOverview",
			{
				showLoadingIndicator: false,
			}
		).subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings(
			"EnableExportESOSupplyForecastOverviewlist",
			{
				showLoadingIndicator: false,
			}
		).subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot(
			"actionpivotEsoSupplyForecast",
			{
				showLoadingIndicator: false,
			}
		).subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipEsoSupplyForecast != null
				&& result[0].defaultSelectionTooltipEsoSupplyForecast.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipEsoSupplyForecast != null
				&& result[0].enableDisableTooltipEsoSupplyForecast.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}
	ScopeList = [];

	loadLengendToShare() {
		var seriesValues = { ScopeList: [] };
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (this.ChartSettings != null) {
			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}
		}
	}

	onLegendClick(e: any){
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}

	goToDeepDive(data: any) {
		if (!data.ProductId) {
			return;
		}
		this.windowService.openInNewPage("/mrp/deep-dive", {
			id: data.ProductId,
		});
	}

	constructor(
		private _activatedRoute: ActivatedRoute,

		private esoService: EsoService,
		private settingsService: SettingsService,
		private shareDataService: ShareDataService,
		private titleService: Title,
		private notificationService: NotificationService,
		private infoBoxService: InfoBoxService, private windowService: WindowService,
		// private confirmationPopUpService: ConfirmationPopUpService,
		private helpService: HelpService,
		private fileExportService: FileExportService,

		private _activatedRouteService: ActivatedRouteService,
	) { }

	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		await firstValueFrom(this._activatedRouteService.routeData$); // Wait until `this._activatedRouteService.routeData$` resolved after navigation end to be able to access initialized `this._activatedRouteService.routeId`.

		// console.error(`${this._activatedRouteService.routeId.toString()}`);

		this.getChartCaptions();
		await this.initializeBookmarks();

		this.getPeriodList();

		this.loadPageData();

		this.GetSettingsData();
		this.WebSettingsPivot();

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(selection) => {
				this.shareDataService.CleanData();
				this.shareDataService.filterOptionOverview = selection.output;
				this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);

				this.getTableData();
				this.getChartData();
				this.clearSelectedItem();

				this.pageFiltersOperator.load(
					{
						showLoadingIndicator: true,
					}
				);

			}
		);

		this.pageFiltersOperator.onFiltersReset.subscribe(
			(_) => {
				this.clearSelectedItem();
			}
		);
	}

	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	  }
}
